<template>
    <div>
      <button type="button" class="icon-btn" title="Edit list" @click="showmodal">
        <feather type="edit-2" size="16"></feather>
      </button>
      <b-modal size="xl" :id="'EditListModal'+ArticleID" title="Edit List" @show="OnShowModal" @hide="clear" hide-footer no-close-on-esc no-close-on-backdrop> 
        <div class="container-fluid">
            <b-modal :ref="'ListEditAlert'+ArticleID" title="Admin" @ok="close()" ok-only>
                <p class="my-4">{{ message }}</p>
            </b-modal>
              <div class="text-right">
                <b-form-checkbox switch size="s" v-model = "form.status"> Active </b-form-checkbox>
              </div>
              <hr>
              <div class="row product-adding">
                    <div class="col-xl-4">
                        <div class="digital-add needs-validation">
                            <div class="form-group">
                            <label
                            for="validationtitle"
                            class="col-form-label pt-0"
                            >Title <span>*</span></label
                            >
                            <ValidationProvider
                            name="Title"
                            rules="required"
                            v-slot="{ errors }"
                            >
                            <input
                                class="form-control"
                                id="validationtitle"
                                type="text"
                                v-model="form.title"
                                required=""
                            />
                            <span
                                class="block text-danger text-xs absolute bottom-0 left-0"
                                >{{ errors[0] }}</span
                            >
                            </ValidationProvider>
                        </div>
                    </div>
                </div>
              <div class="col-xl-4">
                <div class="form-group">
                  <label
                    for="validationslug"
                    class="col-form-label pt-0"
                    >Slug</label
                  >
                    <input
                      class="form-control"
                      id="validationslug"
                      type="text"
                      v-model="form.slug"
                    />
                </div>
              </div>
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label class="col-form-label pt-0"
                      >Category <span>*</span></label
                    >
                    <ValidationProvider
                        name="Category"
                        rules="required"
                        v-slot="{ errors }"
                      >
                     <b-form-select v-model="form.category" :options="getCategories()"></b-form-select>
                    <span class="block text-danger text-xs absolute bottom-0 left-0">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>  
            <div class="row product-adding">
                <div class="col-xl-12">
                    <label class="col-form-label pt-0">Images</label>
                    <vue-dropzone
                        id="DropZone"
                        :options="ImagesOptions"
                        class="dropzone digits"
                        ref="dropzone"
                        :useCustomSlot="true"
                        v-on:vdropzone-success="uploadSuccess"
                        v-on:vdropzone-removed-file="fileRemoved"
                        @vdropzone-complete="uploadComplete"
                        @vdropzone-sending="sending" @vdropzone-error="uploadError">
                    </vue-dropzone>
                    <br/>
                </div>
                <div class="col-xl-12">
                    <label>Introduction</label>
                    <vue-editor v-model="form.introduction"></vue-editor><br/>
                </div>
                <div class="col-xl-12">
                    <label class="col-form-label pt-0">Sections</label>
                    <b-container class="solid">
                        <div v-for="(item, index) in form.article" :key="index">
                            <div class="row product-adding">
                              <h2>{{index +1}}</h2>
                              <div class="col-xl-8">
                                <div class="digital-add needs-validation">
                                    <div class="form-group">
                                    <label
                                    for="validationtitle"
                                    class="col-form-label pt-0"
                                    >Title</label>
                                    <input
                                        class="form-control"
                                        id="validationtitle"
                                        type="text"
                                        v-model="item.title"
                                        required=""
                                    />
                                </div>
                                </div>
                            </div>
                              <div class="col-xl-12">
                                  <label class="col-form-label pt-0">Images</label>
                                  <vue-dropzone
                                      :id=index
                                      :options="ImagesOptionsSection[index]"
                                      class="dropzone digits"
                                      ref="dropzone1"
                                      :index=index
                                      :useCustomSlot="true"
                                      v-on:vdropzone-success="uploadSuccess"
                                      v-on:vdropzone-removed-file="fileRemovedImageSection($event, index)"
                                      @vdropzone-complete="(file, response) => uploadCompleteImageSection(file, index, response)"
                                      @vdropzone-sending="sending" @vdropzone-error="uploadError">
                                  </vue-dropzone>
                                  <br/>
                                </div>
                                <div class="col-xl-12">
                                    <vue-editor v-model="item.section"></vue-editor><br/>
                                </div>  
                            </div>
                            <div class="row product-adding">
                            <div class="col-xl-8">
                                <div class="digital-add needs-validation">
                                    <div class="form-group">
                                    <label
                                    for="validationlink"
                                    class="col-form-label pt-0"
                                    >Link</label>
                                    <input
                                        class="form-control"
                                        id="validationlink"
                                        type="text"
                                        v-model="item.link"
                                        required=""
                                    />
                                </div>
                                </div>
                            </div>
                            <div class="col-xl-4">
                                <div class="digital-add needs-validation">
                                    <div class="form-group">
                                    <label
                                    for="validationrate"
                                    class="col-form-label pt-0"
                                    >Rate</label>
                                    <input
                                        class="form-control"
                                        id="validationtitle"
                                        type="text"
                                        v-model="item.rate"
                                        required=""
                                    />
                                </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-12 text-right">
                            <button type="button" class="btn btn-default" @click="Addsection">
                            Add Section
                            </button> 
                            <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6" @click="Delsection(index)"></feather>
                        </div>
                        <hr>
                        </div>
                    </b-container>
                </div>
                <div class="col-xl-12">
                    <label>Conclusion</label>
                    <vue-editor v-model="form.conclusion"></vue-editor><br/>
                </div>
            </div>
            <div class="row product-adding">
              <div class="col-xl-12">
                <label class="col-form-label pt-0">Reviews</label>
                <b-container class="solid">
                  <div class="col-xl-12 text-right">
                    <button type="button" class="btn btn-default" @click="AddReviews">
                      Add Review
                    </button> 
                  </div>
                  <div v-for="(item, index) in form.reviews" :key="index">
                    <div class="pt-2 pb-2"><hr></div>
                    <div class="row product-adding">
                      <div class="col-xl-3">
                         <div class="form-group">
                          <label
                            for="vname"
                            class="col-form-label pt-0"
                            >Name  </label
                          >     
                          <input
                            class="form-control"
                            id="vname"
                            type="text"
                            v-model="item.name"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-xl-3">
                         <div class="form-group">
                          <label
                            for="vstate"
                            class="col-form-label pt-0"
                            >State  </label
                          >     
                          <input
                            class="form-control"
                            id="vstate"
                            type="text"
                            v-model="item.state"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-xl-3">
                         <div class="form-group">
                          <label
                            for="vrating"
                            class="col-form-label pt-0"
                            >Rate  </label
                          >     
                          <input
                            class="form-control"
                            id="vrating"
                            type="number"
                            v-model="item.rating"
                            required=""
                          />
                        </div>
                      </div>
                      <div class="col-xl-3 pt-4">
                          <feather type="trash" stroke="#4050F6" stroke-width="" size="22px" fill="#4050F6" @click="DelReview(index)"></feather>
                      </div>  
                    </div>
                    <div class="row product-adding" style="padding-left: 20px;padding-right:20px;">
                          <label
                          for="vreview"
                          class="col-form-label pt-0"
                          >Review  </label
                          > 
                          <b-form-textarea
                            id="vreview"
                            v-model="item.review"
                            placeholder="Enter something..."
                            rows="3"
                            max-rows="6"
                          ></b-form-textarea>
                    </div>
                  </div>
                </b-container>
              </div>
            </div>
            <div class="row product-adding">
              <div class="col-xl-4">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label
                      for="validationmetatitle"
                      class="col-form-label pt-0"
                      >Meta title </label
                    >     
                      <input
                        class="form-control"
                        id="validationmetatitle"
                        type="text"
                        v-model="form.meta_title"
                      />
                  </div>
                </div>
              </div> 
              <div class="col-xl-8">
                <div class="digital-add needs-validation">
                  <div class="form-group">
                    <label
                      for="validationmetadescription"
                      class="col-form-label pt-0"
                      >Meta description</label
                    >
                      <input
                        class="form-control"
                        id="validationmetadescription"
                        type="text"
                        v-model="form.meta_description"
                      />
                  </div>
                </div>
              </div> 
            </div>
            <div class="col-xl-12 pb-3">
              <div class="form-group mb-0">
                <div class="product-buttons text-right">
                  <button type="button" class="btn btn-light mr-2" @click="back">
                    Cancel
                  </button>
                  <button type="button" class="btn btn-primary" @click="save">
                    Save
                  </button> 
                </div>
              </div>
            </div>
        </div>
      </b-modal>
    </div>
  </template>
  
  <script>
  import firebase from '@/utils/firestore-shim';
  import { uploadUrl, uploadHeaders, reportUploadError } from './../../../utils/imageUpload';
  import { VueEditor } from "vue2-editor";
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  import VueAutoDropzone from 'vue-auto-dropzone';
  import { uuid } from "vue-uuid";
  export default {
    components: { VueAutoDropzone, VueEditor },
    props:["BlogID","ArticleID", "Data", "categories", "host"],
    data() {
      return {
        form:{
          title:'',
          slug:'',
          introduction:'',
          article:[{
            title:'',
            images:[],
            section:'',
            link:'',
            rate:''
          }],
          conclusion:'',
          images:[],
          status:true,
          category:'',
          meta_title:'',
          meta_description:'',
          reviews:[],
          FirstImage:null
        },
        images:[],
        ImagesOptions: {
          url: uploadUrl,
          headers: uploadHeaders(),
          thumbnailWidth: 150,
          thumbnailHeight: 150,
          maxFiles: 10,
          params: [],
          maxfilesexceeded: function(file) {
  
            },
          accept: function(file, done) {
              done();
          },
          init: function() {
              this.removeAllFiles();
              let images = this.options.params;
              if (images) {
                images.forEach((e) =>{
                  let f = { 
                      size:'12300',
                      name: e.filename,
                      dataURL: e.src,
                  };
                  this.emit("addedfile", f);
                  this.emit("thumbnail", f,f.dataURL);
                  this.emit("complete", f);
                  this.files.push(f);
                });
              }
          },
          maxFilesize: 100,
          addRemoveLinks: true,
          uploadMultiple:true,
          maxThumbnailFilesize:20,
          dictDefaultMessage:
            "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
        },
        ImagesOptionsSection: [{
              url: uploadUrl,
              headers: uploadHeaders(),
              thumbnailWidth: 150,
              thumbnailHeight: 150,
              maxFiles: 10,
              params: [],
              maxfilesexceeded: function(file) {
      
                },
              accept: function(file, done) {
                  done();
              },
              init: function() {
                  this.removeAllFiles();
                  let images = this.options.params;
                  if (images){
                    images.forEach((e) =>{
                      let f = { 
                          size:'12300',
                          name: e.filename,
                          dataURL: e.src,
                      };
                      this.emit("addedfile", f);
                      this.emit("thumbnail", f,f.dataURL);
                      this.emit("complete", f);
                      this.files.push(f);
                    });
                  }
              },
              maxFilesize: 100,
              addRemoveLinks: true,
              uploadMultiple:true,
              maxThumbnailFilesize:20,
              dictDefaultMessage:
                "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
            }],
        message:"",
        error:0,
        editor: ClassicEditor,
        imagePreview : null
      };
    },
    mounted(){
    
    },
  methods:{
      async save() {
        this.error = 0;
        if (this.form.title=="") {
          this.message = "The Title field is required !";
            this.error = 1;
            this.$refs['ListEditAlert'+this.id].show();
            return false;
        }
        if (this.form.category=="") {
          this.message = "The Category field is required !";
            this.error = 1;
            this.$refs['ListEditAlert'+this.id].show();
            return false;
        }
        this.form.FirstImage=this.form.images[0].src;
        let ref = firebase.firestore().collection('Sites').doc(this.BlogID).collection('List').doc(this.ArticleID);
        await ref.set(this.form)
        .then(() => {
            this.message = "Document successfully written!";
            this.error = 0;
            this.$refs['ListEditAlert'+this.ArticleID].show()
            this.$emit('ok',this.form); 
        })
        .catch((error) => {
            this.message = "Error writing document: " + error;
            this.error = 1;
            this.$refs['ListEditAlert'+this.ArticleID].show()
        }); 
      },
      async getProduct() {
        let listData={};
        var ArticleRef = firebase.firestore().collection("Sites").doc(this.BlogID).collection("Articles").doc(this.ArticleID);
        await ArticleRef.get().then((e) => {
            let element = {};
            element = e.data();
            element.id = e.id;
            listData.push(element);
          });
          return listData;
      },
      close(){
        if (this.error == 0) this.$bvModal.hide('EditListModal'+this.ArticleID);
      },
      back(){
        this.$bvModal.hide('EditListModal'+this.ArticleID);
      },
      showmodal(){
        this.$bvModal.show('EditListModal'+this.ArticleID);
      },
      OnShowModal(){
        let x = this.Data;
        this.form={};
        this.form =x;
        this.ImagesOptions.params = x.images;
        this.images = x.images;
        for (var i=0; i<= x.article.length-1; i++){
          if (i>0){
          this.ImagesOptionsSection.push({
                  url: uploadUrl,
                  headers: uploadHeaders(),
                  thumbnailWidth: 150,
                  thumbnailHeight: 150,
                  maxFiles: 10,
                  params: [],
                  maxfilesexceeded: function(file) {
          
                    },
                  accept: function(file, done) {
                      done();
                  },
                  init: function() {
                      this.removeAllFiles();
                      let images =  this.options.params;
                      if (images){
                        images.forEach((e) =>{
                        let f = { 
                            size:'12300',
                            name: e.filename,
                            dataURL: e.src,
                        };
                        this.emit("addedfile", f);
                        this.emit("thumbnail", f,f.dataURL);
                        this.emit("complete", f);
                        this.files.push(f);
                      });
                    }
                  },
                  maxFilesize: 100,
                  addRemoveLinks: true,
                  uploadMultiple:true,
                  maxThumbnailFilesize:20,
                  dictDefaultMessage:
                    "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
                });
              }
          this.ImagesOptionsSection[i].params.push(x.article[i].images[0]);
        }
      },
      clear(){
        this.form={};
        this.ImagesOptionsSection= [{
              url: uploadUrl,
              headers: uploadHeaders(),
              thumbnailWidth: 150,
              thumbnailHeight: 150,
              maxFiles: 10,
              params: [],
              maxfilesexceeded: function(file) {
      
              },
              accept: function(file, done) {
                done();
              },
              init: function() {
                this.removeAllFiles();
                  let images = this.options.params;
                  images.forEach((e) =>{
                  let f = { 
                    size:'12300',
                    name: e.filename,
                    dataURL: e.src,
                  };
                  this.emit("addedfile", f);
                  this.emit("thumbnail", f,f.dataURL);
                  this.emit("complete", f);
                  this.files.push(f);
                });
              },
              maxFilesize: 100,
              addRemoveLinks: true,
              uploadMultiple:true,
              maxThumbnailFilesize:20,
              dictDefaultMessage:
                "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
            }]
      },
      uploadComplete(file, response){
        // L'API renvoie directement { url: '/uploads/...' } : l'image est
        // déjà stockée sur le serveur, plus besoin de renvoyer l'aperçu.
        try {
          var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
          this.form.images.push({
            'image_id':this.$uuid.v1(),
            'src':data.url,
            'alt':"",
            'variant_id':[],
            'filename':this.$uuid.v1()
          });
        } catch (e) {
          reportUploadError(this, e.message);
        }
      },
      uploadError(file, message) {
        reportUploadError(this, message);
      },
      sending(file, xhr, formData) {
        // Juste avant l'envoi : indique à l'API le dossier de stockage.
        formData.append('folder', 'blogs/' + this.host);
      },
      uploadSuccess(file){
  
      },
      fileRemoved(file){
        if (!this.form.images) return false;
        this.form.images = this.form.images.filter((e) => e.filename!=file.name);
      },
      uploadCompleteImageSection(file, index, response){
        try {
          var data = typeof response === 'string' ? JSON.parse(response) : (response || {});
          this.form.article[index].images.push({
            'src':data.url,
            'filename':this.$uuid.v1()
          });
        } catch (e) {
          reportUploadError(this, e.message);
        }
      },
      fileRemovedImageSection(file, index){
       if (index < this.$refs.dropzone.length-1){
        this.form.article[index].images = this.form.article[index].images.filter((e) => e.filename!=file.name);
       }
      },
      removeAllFiles(){

      },
      getCategories(){
        if (!this.categories) return [];
        let categories =[]
        this.categories.forEach((e) => {
          categories.push({ value: e.category, text: e.category });
        });
        return categories;
      },
      hide(){
        this.form={};
      },
      AddVariants(){
        this.form.variants.push(
          {
            option:'',
            value:[]
          }
        );
      },
      AddReviews(){
        this.form.reviews.push(
          {
            name:'',
            state:'',
            rating:5,
            review:''
          }
        );
      },
      Addsection(){
        this.form.article.push(
            {
              title:'',
              images:[],
              section:'',
              link:'',
              rate:''
            }
        );
        this.ImagesOptionsSection.push({
                  url: uploadUrl,
                  headers: uploadHeaders(),
                  thumbnailWidth: 150,
                  thumbnailHeight: 150,
                  maxFiles: 10,
                  params: [],
                  maxfilesexceeded: function(file) {
          
                    },
                  accept: function(file, done) {
                      done();
                  },
                  init: function() {
                    this.removeAllFiles();
                      let images =  this.options.params;
                      if (images){
                        images.forEach((e) =>{
                          let f = { 
                              size:'12300',
                              name: e.filename,
                              dataURL: e.src,
                          };
                          this.emit("addedfile", f);
                          this.emit("thumbnail", f,f.dataURL);
                          this.emit("complete", f);
                          this.files.push(f);
                        });
                      }
                  },
                  maxFilesize: 100,
                  addRemoveLinks: true,
                  uploadMultiple:true,
                  maxThumbnailFilesize:20,
                  dictDefaultMessage:
                    "<i class='icon-cloud-up'></i><h6>Drop image here or click to upload. 600 x 600 px</h6><</span>",
                });
      },
      Delsection(index){
        if (index!=0)  this.form.article.splice(index,1);
      },
      DelVariants(index){
        this.form.variants.splice(index,1);
        this.generateVariants();
      },
      DelReview(index){
        this.form.reviews.splice(index,1);
      },
      generateVariants(){
        var result=[];
        if (this.form.variants.length==1){
            for (let i=0; i<this.form.variants[0].value.length; i++){
              result.push({
                "option": this.form.variants[0].option,
                "value": this.form.variants[0].value[i],
                "price":this.form.price,
                "compare_at_price":this.form.compare_at_price,
                "default":"false"
              })
            }
        }
        if (this.form.variants.length==2){
            for (let i=0; i<this.form.variants[0].value.length; i++){
              for(let j=0; j<this.form.variants[1].value.length; j++){
                result.push({
                  "option": [this.form.variants[0].option, this.form.variants[1].option],
                  "value": [this.form.variants[0].value[i], this.form.variants[1].value[j]],
                  "price":this.form.price,
                  "compare_at_price":this.form.compare_at_price,
                  "default":"false"
                })
              }
            }
        }
        this.form.TablePriceVariants=result;
      }
    }
  };
  </script>
  <style>
      .dropzone .dz-preview .dz-image img {
          display: block;
          width: 150px;
          height: 150px;
      } 
      .solid{
        border: 2px dashed #ff8084;
        border-radius: 4px;
        padding: 20px;
        margin-bottom: 20px;
      }
      
  </style>